(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         *
         */
        .controller('LoginCtrl', ['$scope', 'jwtService', 'sharedDataService', '$location', '$stateParams', '$state', 'themeService',
            function ($scope, jwtService, sharedDataService, $location, $stateParams, $state, themeService) {

                function getReturnUrl() {
                    const queryParams = $location.search();
                    const paramKey = Object.keys(queryParams).find((key) => key.toLowerCase() === 'returnurl');
                    return paramKey ? decodeURIComponent(queryParams[paramKey]) : "";
                }

                $scope.user = {};
                if ($location.search().user) {
                    $scope.user.userId = $location.search().user;
                }
                jwtService.clear();
                sharedDataService.clearCache();
                $scope.loginError = false;

                $scope.login = function () {
                    const returnUrl = getReturnUrl();
                    jwtService.login($scope.user.userId, $scope.user.password, returnUrl)
                        .then(function (result) {
                            themeService.loadTheme();
                            return result;
                        })
                        .then(function(result){
                            if (result.data.status === 'SuccessfulLogin') {
                                if ($stateParams.link && $stateParams.link != '/login') {
                                    $location.path($stateParams.link);
                                } else {
                                    if (returnUrl) {
                                        jwtService.silentLogOnJwt(returnUrl);
                                    } else {
                                        $location.path("/home");
                                    }
                                }
                            }
                        })
                        .catch(function (error) {
                            if (error.status == 401 && error.data.status == "UserNotActivated") {
                                $state.go('register', { userData: { email: $scope.user.userId, accountId: error.data.accountId, userId: error.data.userId, verifyKey: error.data.verifyKey,  password: $scope.user.password} });
                            }
                            else {
                                $scope.loginError = true;
                                $scope.loginErrorCode = error.status;
                                if (error.data.status === "IncorrectUserNameOrPasswordUserNowLocked" || error.data.status ==="UserLocked") {
                                    $scope.accountLocked = true;
                                }
                                console.error("login errored", error);
                            }
                        });

                };

            }]);

})(window.angular);
